var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v("Nome completo")]),_vm._v(" e "),_c('b',[_vm._v("Tipo de Pessoa")]),_vm._v(" são obrigatórios! ")])}]

export { render, staticRenderFns }